import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";

const TextField = (props) => {
    const {
        type, change, field, value, disabled, formatter = val => val, saveFormatter = val => val,
        onChange: onChangeHandler = () => {}, onRender, data, resize = false
    } = props;
    const [current, setCurrent] = useState(formatter(value || '')  || '');
    const elem = useRef(null);

    const onFocus = (e) => {
        props.onFocus && props.onFocus(e);
    };
    const onBlur = (e) => {
        props.onBlur && props.onBlur(e);
        const saveFormattedValue = saveFormatter(current);
        if (saveFormattedValue !== value) {
            change(saveFormattedValue, field);
        }
    };
    const onChange = (e) => {
        const formattedValue = formatter(e.target.value) || ``;
        setCurrent(formattedValue);
        if (formattedValue !== value) {
            change(formattedValue, field);
        }
        onChangeHandler(e.target);
    };

    useEffect(() => {
        onRender && onRender(elem.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setCurrent(formatter(value || '')  || '');
    }, [value, formatter]);


    const rows = (data && typeof data.rows === 'number') ? data.rows : 1;
    const isTextarea = type === 'textarea' || rows > 1;
    const inputClassName = classnames('form-input__input', { resize: isTextarea && resize });

    return isTextarea ? (
        <textarea
            name={field}
            value={current}
            onChange={onChange}
            className={inputClassName}
            id={"column-" + field}
            onFocus={onFocus}
            onBlur={onBlur}
            disabled={disabled}
            rows={rows > 1 ? rows : 4}
            ref={elem}
        />
    ) : (
        <input
            name={field}
            value={current}
            onChange={onChange}
            className={inputClassName}
            type="text"
            id={"column-" + field}
            onFocus={onFocus}
            onBlur={onBlur}
            disabled={disabled}
            ref={elem}
        />
    );
}

export default TextField;
